import { FC } from 'react';
import { TypeDisclaimer } from 'components/library/Typography';
import {
  ViaCapWrapper,
  ViaCapTextColumn,
  ViaCapDottedLine,
  ViaCapSubhead,
  ViaCapVideoContainer,
  ViaCapNestedColumn,
  Spacer,
} from './via-cap.styled';
import { ViaCapVideoPlayer } from './via-cap-video-player';

const viaCapTopVariants = {
  initial: { y: '20px' },
  animate: {
    y: '-10px',
    transition: {
      duration: 0.5,
      delay: 0.25,
      when: 'beforeChildren',
      staggerChildren: 1,
    },
  },
};

const viaCapBottomVariants = {
  initial: { y: '-20px' },
  animate: {
    y: '10px',
    transition: {
      duration: 0.5,
      delay: 0.25,
    },
  },
};

interface ViaCapElementProps {
  paused?: boolean;
  capsule?: {
    media: {
      src: string;
      alt: string;
      width: number;
      height: number;
      type?: string;
      fallbackSrc: string;
      fallbackStillSrc?: string;
    };
    top: {
      title: string;
      body: string;
    };
    center?: {};
    bottom: {
      title: string;
      body: string;
    };
  };
}

export const ViaCapElementLarge: FC<ViaCapElementProps> = ({
  paused,
  capsule = {
    media: {
      src: '',
      fallbackSrc: '',
      alt: '',
      width: 69,
      height: 48,
      type: 'video',
    },
    top: {
      title: '',
      body: '',
    },
    center: {},
    bottom: {
      title: '',
      body: '',
    },
  },
}) => {
  return (
    <>
      <ViaCapWrapper>
        <ViaCapVideoContainer>
          <ViaCapVideoPlayer
            src={capsule.media.src}
            fallbackSrc={capsule.media.fallbackSrc}
            fallbackStillSrc={capsule.media.fallbackStillSrc}
            paused={paused}
            alt={capsule.media.alt}
            width={capsule.media.width}
            height={capsule.media.height}
          />
        </ViaCapVideoContainer>

        <ViaCapNestedColumn $position='left'>
          <ViaCapTextColumn
            $position='left'
            variants={viaCapTopVariants}
            initial='initial'
            whileInView='animate'
          >
            <ViaCapSubhead>{capsule.top.title}</ViaCapSubhead>
            <TypeDisclaimer color='inverse-primary'>
              {capsule.top.body}
            </TypeDisclaimer>
          </ViaCapTextColumn>
          <ViaCapDottedLine $position='left' $alignSelf='flex-start' />
        </ViaCapNestedColumn>

        <Spacer $width='100px' />

        <ViaCapNestedColumn $position='right'>
          <ViaCapDottedLine $position='right' $alignSelf='center' />
          <ViaCapTextColumn
            $position='right'
            variants={viaCapBottomVariants}
            initial='initial'
            whileInView='animate'
          >
            <ViaCapSubhead>{capsule.bottom.title}</ViaCapSubhead>
            <TypeDisclaimer color='inverse-primary'>
              {capsule.bottom.body}
            </TypeDisclaimer>
          </ViaCapTextColumn>
        </ViaCapNestedColumn>
      </ViaCapWrapper>
    </>
  );
};
